import { Controller } from "@hotwired/stimulus"
import { i18n } from "../lib/i18n"

/**
 * Fields Filter Controller
 *
 * Provides search and filter functionality for the fields table
 * in the ReportDataSource admin interface.
 */
export default class extends Controller {
  static targets = [
    "searchInput",
    "typeFilter",
    "originFilter",
    "visibleFilter",
    "joinFilter",
    "fieldRow",
    "matchCount",
    "introspectedSection"
  ]
  
  connect() {
    this.filterFields()
  }

  filterFields() {
    const searchTerm = this.hasSearchInputTarget ? this.searchInputTarget.value.toLowerCase() : ""
    const typeFilter = this.hasTypeFilterTarget ? this.typeFilterTarget.value : ""
    const originFilter = this.hasOriginFilterTarget ? this.originFilterTarget.value : ""
    const visibleOnly = this.hasVisibleFilterTarget ? this.visibleFilterTarget.checked : false
    const joinOnly = this.hasJoinFilterTarget ? this.joinFilterTarget.checked : false

    let matchCount = 0
    let totalCount = 0

    this.fieldRowTargets.forEach(row => {
      totalCount++
      const key = row.dataset.fieldKey || ""
      const label = row.dataset.fieldLabel || ""
      const type = row.dataset.fieldType || ""
      const origin = row.dataset.fieldOrigin || ""
      const visible = row.dataset.fieldVisible === "true"
      const needsJoin = row.dataset.fieldNeedsJoin === "true"

      let show = true

      // Search filter
      if (searchTerm && !key.toLowerCase().includes(searchTerm) && !label.toLowerCase().includes(searchTerm)) {
        show = false
      }

      // Type filter
      if (typeFilter && type !== typeFilter) {
        show = false
      }

      // Origin filter
      if (originFilter && origin !== originFilter) {
        show = false
      }

      // Visible filter
      if (visibleOnly && !visible) {
        show = false
      }

      // Needs join filter
      if (joinOnly && !needsJoin) {
        show = false
      }

      row.style.display = show ? "" : "none"

      if (show) {
        matchCount++
      }
    })

    // Update match count display
    if (this.hasMatchCountTarget) {
      if (searchTerm || typeFilter || originFilter || visibleOnly || joinOnly) {
        this.matchCountTarget.textContent = i18n.t('fields_filter.match_count', { match_count: matchCount, total_count: totalCount })
        this.matchCountTarget.classList.remove("hidden")
      } else {
        this.matchCountTarget.classList.add("hidden")
      }
    }

    // Hide/show introspected section based on filters
    if (this.hasIntrospectedSectionTarget) {
      const hasActiveFilters = searchTerm || typeFilter || originFilter || visibleOnly || joinOnly
      this.introspectedSectionTarget.style.display = hasActiveFilters ? "none" : ""
    }
  }

  clearFilters() {
    if (this.hasSearchInputTarget) this.searchInputTarget.value = ""
    if (this.hasTypeFilterTarget) this.typeFilterTarget.value = ""
    if (this.hasOriginFilterTarget) this.originFilterTarget.value = ""
    if (this.hasVisibleFilterTarget) this.visibleFilterTarget.checked = false
    if (this.hasJoinFilterTarget) this.joinFilterTarget.checked = false

    this.filterFields()
  }
}
